import { feature } from 'topojson-client';

interface MinimalTopology {
  objects: Record<string, unknown>;
}

/** Convert one named object of a us-atlas TopoJSON into GeoJSON features. */
export function topoToFeatures(topo: unknown, objectName: string): GeoJSON.Feature[] {
  const t = topo as MinimalTopology;
  const obj = t.objects?.[objectName];
  if (!obj) return [];
  // topojson-client's types are strict about the Topology shape; our bundled
  // us-atlas files conform at runtime, so cast through unknown.
  const fc = feature(t as never, obj as never) as unknown as GeoJSON.FeatureCollection;
  return fc.features;
}

/**
 * Every county-level polygon in the bundled county topology: the us-atlas
 * counties plus Connecticut's 2022 planning regions (09110–09190), which the
 * permits pipeline keys CT county rows on (#166). The two CT sets overlap, so
 * only lookup-by-id consumers (permit coverage) should use this; the parcel maps
 * paint every county in a state and stay on the legacy `counties` object.
 */
export function countyLevelFeatures(topo: unknown): GeoJSON.Feature[] {
  return [...topoToFeatures(topo, 'counties'), ...topoToFeatures(topo, 'ct_regions')];
}
